export const AUTHORIZE_TIMEOUT_MS = 15000;
export const TOKEN_EXPIRY_BUFFER_MS = 30000;
export const UNAUTHORIZED_STATUS_CODE = 401;
